



















import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'RecordSelect',
    props: {
        value: { type: String, default: '' },
        objectType: { type: String, required: true }, // 'contacts' or 'companies'
        placeholder: { type: String, default: 'Search...' }
    },
    data() {
        return {
            isOpen: false,
            search: '',
            results: [] as any[],
            loading: false,
            debounceTimer: null as any,
            selectedLabel: ''
        }
    },
    computed: {
        currentLabel(): string {
            if(!this.value) return this.placeholder;
            return this.selectedLabel || this.value;
        },
        searchPlaceholder(): string {
            return this.objectType === 'contacts' ? 'Search by email or last name...' : 'Search by name...';
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
        clearTimeout(this.debounceTimer);
        document.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
        toggleOpen() {
            this.isOpen = !this.isOpen;
            if(this.isOpen) {
                this.search = '';
                this.results = [];
            }
        },
        formatLabel(r: any): string {
            if(this.objectType === 'contacts') {
                const name = [r.properties.firstname, r.properties.lastname].filter(Boolean).join(' ');
                return name ? `${name} (${r.properties.email || 'no email'})` : (r.properties.email || r.id);
            }
            return r.properties.name || r.id;
        },
        select(r: any | null) {
            if(!r) {
                this.selectedLabel = '';
                this.$emit('input', '');
            } else {
                this.selectedLabel = this.formatLabel(r);
                this.$emit('input', r.id);
            }
            this.isOpen = false;
        },
        searchDebounce() {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => { this.runSearch() }, 400);
        },
        runSearch() {
            if(!this.search) {
                this.results = [];
                return;
            }
            this.loading = true;
            axios.get(`${this.$store.state.apiUrl}/hsdata/search/${this.objectType}/${encodeURIComponent(this.search)}`)
                .then(resp => {
                    this.results = resp.data;
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e);
                    this.loading = false;
                });
        },
        handleOutsideClick(event: MouseEvent) {
            if(this.isOpen && this.$el && !this.$el.contains(event.target as Node)) {
                this.isOpen = false;
            }
        }
    }
})
